import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import ContextProviderUtilities from './ContextProviderUtilities';

const [useContext, Provider] = ContextProviderUtilities();

const useActioningContext = useContext;

export const ActioningProviderUtilities = ({ children }) => {
    const [isActioning, setIsActioning] = useState(false);
    const contextValue = useMemo(
        () => ({
            isActioning,
            setIsActioning,
        }),
        [isActioning, setIsActioning]
    );
    return <Provider value={contextValue}>{children}</Provider>;
};

ActioningProviderUtilities.propTypes = {
    children: PropTypes.node,
};

ActioningProviderUtilities.defaultProps = {
    children: null,
};

export default useActioningContext;
